module.exports = __webpack_public_path__ + "img/headerJR.1b61fb0a.png";